<template>
	<div class="saveCard">
		<span>
			<img v-if="icon" :src="icon" />
			{{ title }}
		</span>
		<div class="s_box">
			<template v-for="item in data">
				<div
					:key="item.sid"
					@click="openAppUrl(item)"
					v-if="data.length > 0 && item.id"
				>
					<div>
						<el-image
							v-if="item.json.icon"
							style="width: 100%; height: 100%"
							:src="item.json.icon"
							fit="cover"
						></el-image>
						<svg
							v-else
							t="1732605901531"
							class="icon"
							viewBox="0 0 1024 1024"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							p-id="4275"
							width="200"
							height="200"
						>
							<path
								d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
								fill="#2C6DD2"
								p-id="4276"
							></path>
							<path
								d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
								fill="#20C997"
								p-id="4277"
							></path>
						</svg>
					</div>
					<span>{{ item.name }}</span>

					<div class="del" @click.stop="delItem(item)">
						<img src="@/assets/img/appCenter/del_icon2.svg">
					</div>
				</div>
			</template>

			<span v-if="data.length == 0">{{ lang.noData }}...</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: "标题",
		},
		data: {
			type: Array,
			default: () => [],
		},
		type: {
			type: Number,
			default: 0,
		},
		icon: {
			type: String,
			default: "",
		},
	},
	data() {
		return {};
	},
	methods: {
		openAppUrl(item) {
			this.$emit("saveClick", item, this.type);
			// window.open(item.url, "_blank");
		},
		delItem(item){
			if(this.type==0 && this.$parent.collectFn){
				let _copyItem = JSON.parse(JSON.stringify(item))
				_copyItem.collectId = item.sid;
				_copyItem.id = item.id;				
				this.$parent.collectFn(_copyItem,1)
			}else if(this.type==1 && this.$parent.cancelAppStoreSave){
				this.$parent.cancelAppStoreSave(item)
			}
			console.log(item)
		}
	},
};
</script>

<style scoped>
.saveCard {
	width: 100%;
	height: auto;
	margin-bottom: 10px;
	box-sizing: border-box;
	padding: 10px;
}

.saveCard > span {
	font-size: 16px;
	font-weight: 400;
	display: flex;
	color: #00000066;
	align-items: center;
	margin-left: 0px;
}

.saveCard > span > img {
	width: 20px;
	height: 20px;
	margin-right: 5px;
}

.s_box {
	width: 100%;
	height: auto;
	padding-top: 10px;
}

.s_box > div {
	width: calc(100% + 20px);
	height: 35px;
	margin-top: 8px;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	border-radius: 5px;
	cursor: pointer;
	transition: 0.3s;
	position: relative;
	left: -10px;
	box-sizing: border-box;
	padding-left: 10px;

}

.s_box > div:hover {
	background-color: #e9f2fc;
}

.s_box > div > div {
	width: 22px;
	height: 22px;
	box-sizing: border-box;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 10px;
	margin-left: 0px;
}

.s_box > div > div > svg {
	width: 100%;
	height: 100%;
}

.s_box > div > div > span >>> svg {
	width: 100%;
	height: 100%;
}

.s_box > div > span {
	max-width: calc(100% - 80px);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;
	font-weight: 400;
	color: #000000e5;
}

.s_box > span {
	font-size: 0.8em;
}

.s_box>div:hover .del{
	display: block;
}

.del{
	width: 20px !important;
	height: 20px !important;
	position: absolute;
	right: 0px;
	display: none;
	/* top: 10px; */
}

.del>img{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
</style>
